<template>
    <div class="">
        <button-primary
            button-style="danger"
            @keydown.alt.t="isCreateModalOpen = true"
            @click="isCreateModalOpen = true"
            >{{ $t("incidents.buttons.create") }}
        </button-primary>

        <dialog-modal :show="isCreateModalOpen">
            <template #title>
                <progress-steps
                    :steps="steps"
                    :current-step="currentStep"
                    @item-click="currentStep = $event"
                ></progress-steps>
            </template>

            <template #content class="bg-gray-50">
                <div v-show="currentStep === 0" class="w-full">
                    <affected-project-selector
                        :all-projects="$page.props.allProjects"
                        @affected-projects="incidentData.affectedProjects = $event"
                    ></affected-project-selector>

                    <ul v-if="errors.affectedProjects">
                        <li v-for="error in errors.affectedProjects" :key="error" class="text-red-500 text-xs">
                            {{ error }}
                        </li>
                    </ul>
                </div>
                <div v-if="currentStep === 1" class="w-full">
                    <div class="flex flex row my-2">
                        <div
                            v-for="intergration in intergrations.data"
                            :key="intergration.id"
                            :class="[
                                intergration.name === intergrations.active ? activeSytling : 'bg-white',
                                'py-2 px-4 m-2 cursor-pointer',
                            ]"
                            @click="intergrations.active = intergration.name"
                        >
                            <h4 class="text-md text-gray-800 hover:text-gray-300">{{ intergration.name }}</h4>
                        </div>
                    </div>
                    <create-sensu-intergration
                        v-if="intergrations.active === 'sensu'"
                        :pre-selected-events="incidentData.projectChecks.sensu"
                        @sensu-project-check="setSensuProjectCheck"
                    ></create-sensu-intergration>
                    <div v-if="intergrations.active === 'UptimeRobot'" class="w-11/12 text-center">
                        This feature is not approved by the zucc yet... <br />
                        He is smoking his meet
                    </div>
                </div>
                <div v-if="currentStep === 2" class="w-full">
                    <text-input
                        v-model="incidentData.title"
                        :label="$t('incidents.forms.title.title')"
                        :errors="errors.title"
                        :placeholder="$t('incidents.forms.title.placeholder')"
                    ></text-input>

                    <text-area-input
                        v-model="incidentData.description"
                        :label="$t('incidents.forms.description.title')"
                        :placeholder="$t('incidents.forms.description.placeholder')"
                        :errors="errors.description"
                        class="mt-2"
                    ></text-area-input>

                    <div class="flex flex-wrap w-full">
                        <div class="block w-full md:w-1/2 md:pr-2">
                            <p class="mt-2 text-gray-800 text-sm">Prioriteit</p>
                            <select
                                v-model="incidentData.prio"
                                class="
                                    w-full
                                    bg-gray-50
                                    rounded
                                    border border-gray-300
                                    focus:border-lightblue-500
                                    focus:outline-none
                                "
                            >
                                <option value="Low">
                                    {{ $t("incidents.forms.priority.items.low") }}
                                </option>
                                <option value="Medium">
                                    {{ $t("incidents.forms.priority.items.medium") }}
                                </option>
                                <option value="High">
                                    {{ $t("incidents.forms.priority.items.high") }}
                                </option>
                            </select>
                        </div>

                        <div class="block w-full md:w-1/2 md:pl-2">
                            <p class="mt-2 text-gray-800 text-sm">
                                {{ $t("incidents.forms.status.title") }}
                            </p>
                            <select
                                v-model="incidentData.resolved"
                                class="
                                    w-full
                                    bg-gray-50
                                    rounded
                                    border border-gray-300
                                    focus:border-lightblue-500
                                    focus:outline-none
                                "
                            >
                                <option :value="false">
                                    {{ $t("incidents.forms.status.items.active") }}
                                </option>
                                <option :value="true">
                                    {{ $t("incidents.forms.status.items.fixed") }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="currentStep === 3" class="w-full">
                    <dl>
                        <div class="bg-gray-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500" :class="{ 'text-red-500': errors.title }">
                                {{ $t("incidents.forms.title.title") }}
                            </dt>
                            <dd
                                class="mt-1 text-sm sm:mt-0 sm:col-span-2"
                                :class="incidentData.title ? 'text-gray-900' : 'text-gray-500 italic'"
                            >
                                {{ incidentData.title ? incidentData.title : $t("incidents.forms.errors.empty") }}
                            </dd>
                        </div>
                        <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt
                                class="text-sm font-medium text-gray-500"
                                :class="{ 'text-red-500': errors.description }"
                            >
                                {{ $t("incidents.forms.description.title") }}
                            </dt>
                            <dd
                                class="mt-1 text-sm sm:mt-0 sm:col-span-2"
                                :class="incidentData.description ? 'text-gray-900' : 'text-gray-500 italic'"
                            >
                                {{
                                    incidentData.description
                                        ? incidentData.description
                                        : $t("incidents.forms.errors.empty")
                                }}
                            </dd>
                        </div>
                        <div class="bg-gray-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                {{ $t("incidents.forms.priority.title") }}
                            </dt>
                            <dd class="flex mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ incidentData.prio }}
                            </dd>
                        </div>
                        <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                {{ $t("incidents.forms.status.title") }}
                            </dt>
                            <dd class="flex mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                <div
                                    class="h-3 w-3 rounded-full mr-2 my-auto"
                                    :class="incidentData.resolved ? 'bg-green-500' : 'bg-yellow-500'"
                                ></div>
                                {{
                                    incidentData.resolved
                                        ? $t("incidents.forms.status.items.solved")
                                        : $t("incidents.forms.status.items.active")
                                }}
                            </dd>
                        </div>
                        <div class="bg-gray-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt
                                class="text-sm font-medium text-gray-500"
                                :class="{
                                    'text-red-500': errors.affectedProjects,
                                }"
                            >
                                {{ $t("incidents.forms.affected_projects.title") }}
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                <ul
                                    v-if="incidentData.affectedProjects.length > 0"
                                    class="bg-gray-50 border border-gray-200 rounded-md divide-y divide-gray-200"
                                >
                                    <li
                                        v-for="project in allProjects"
                                        v-show="incidentData.affectedProjects.includes(project.id)"
                                        :key="project.id"
                                        class="pl-3 pr-4 py-3 text-sm"
                                    >
                                        <p>{{ project.name }}</p>
                                        <a
                                            :href="project.website_url"
                                            target="_blank"
                                            class="
                                                hidden
                                                sm:flex
                                                font-medium
                                                text-lightblue-700
                                                hover:text-lightblue-500
                                            "
                                            >{{ project.website_url }}</a
                                        >
                                        <a
                                            :href="project.website_url"
                                            target="_blank"
                                            class="sm:hidden font-medium text-lightblue-700 hover:text-lightblue-500"
                                            >Link</a
                                        >
                                    </li>
                                </ul>

                                <div v-else class="italic text-gray-500">
                                    {{ $t("incidents.forms.affected_projects.empty") }}
                                </div>
                            </dd>
                        </div>
                        <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt
                                class="text-sm font-medium text-gray-500"
                                :class="{
                                    'text-red-500': errors.projectChecks,
                                }"
                            >
                                {{ $t("incidents.forms.project_checks.sensu.title") }}
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                <ul
                                    v-if="incidentData.projectChecks.sensu.length"
                                    class="bg-gray-50 border border-gray-200 rounded-md divide-y divide-gray-200"
                                >
                                    <li
                                        v-for="sensuEvent in incidentData.projectChecks.sensu"
                                        :key="sensuEvent.id"
                                        class="pl-3 pr-4 py-3 text-sm"
                                    >
                                        <p>{{ sensuEvent.entity }} {{ sensuEvent.check }}</p>
                                        <div class="flex flex-row">
                                            <div
                                                class="h-3 w-3 rounded-full mx-2 my-auto"
                                                :class="sensuStateColors[sensuEvent.status]"
                                            ></div>
                                            {{ sensuEvent.state }}
                                        </div>
                                    </li>
                                </ul>

                                <div v-else class="italic text-gray-500">
                                    {{ $t("incidents.forms.project_checks.sensu.empty") }}
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>
            </template>

            <template #footer>
                <div class="flex">
                    <button-secondary button-style="danger" class="mr-auto" @button-click="cancelCreate()"
                        >{{ $t("incidents.buttons.cancel") }}
                    </button-secondary>
                    <button-secondary v-if="currentStep > 0" class="mr-4" @button-click="currentStep--"
                        >{{ $t("incidents.buttons.previous") }}
                    </button-secondary>

                    <button-primary v-if="currentStep < steps.length - 1" @button-click="currentStep++"
                        >{{ $t("incidents.buttons.next") }}
                    </button-primary>
                    <button-primary
                        v-else
                        button-style="success"
                        :show-loading-indicator="isSubmitting"
                        @button-click="createIncident"
                        >{{ $t("incidents.buttons.create_finish") }}
                    </button-primary>
                </div>
            </template>
        </dialog-modal>
    </div>
</template>

<script>
import DialogModal from "@/Jetstream/DialogModal";
import ProgressSteps from "@/Components/ProgressSteps";
import ButtonSecondary from "@/Components/ButtonSecondary";
import ButtonPrimary from "@/Components/ButtonPrimary";
import { computed, reactive, ref, watch } from "vue";
import { Inertia } from "@inertiajs/inertia";
import AffectedProjectSelector from "@/Components/AffectedProjectSelector";
import CreateSensuIntergration from "./CreateSensuIntergration";
import TextInput from "./TextInput";
import TextAreaInput from "./TextAreaInput";

export default {
    name: "CreateIncident",
    components: {
        TextAreaInput,
        TextInput,
        AffectedProjectSelector,
        CreateSensuIntergration,
        ButtonPrimary,
        ButtonSecondary,
        DialogModal,
        ProgressSteps,
    },
    props: {
        allProjects: {
            type: Array,
            required: true,
        },
        openModal: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorBags: {
            type: Object,
        },
    },
    setup(props) {
        const isCreateModalOpen = ref(props.openModal);
        const showErrors = ref(false);
        const isSubmitting = ref(false);
        const currentStep = ref(0);
        const sensuStateColors = ref(["bg-green-500", "bg-yellow-500", "bg-red-500"]);
        const steps = ref([
            {
                icon: "server",
                text: "incidents.timeline.projects",
                hasIssue: false,
            },
            {
                icon: "plug",
                text: "incidents.timeline.integrations",
                hasIssue: false,
            },
            {
                icon: "exclamation-triangle",
                text: "incidents.timeline.incident",
                hasIssue: false,
            },
            {
                icon: "clipboard-check",
                text: "incidents.timeline.overview",
                hasIssue: false,
            },
        ]);

        watch(
            () => props.openModal,
            (selection) => {
                isCreateModalOpen.value = selection;
            }
        );

        const incidentData = ref({
            title: "",
            description: "",
            resolved: false,
            prio: "Medium",
            affectedProjects: [],
            projectChecks: {
                sensu: [],
                uptimeRobot: [],
            },
        });
        const errors = computed(() => {
            if (!showErrors.value) {
                return {};
            }

            return props.errorBags.default ? props.errorBags.default : {};
        });

        const intergrations = reactive({
            data: {
                sensu: {
                    name: "sensu",
                    active: true,
                },
                UptimeRobot: {
                    name: "UptimeRobot",
                    active: false,
                },
            },
            active: "sensu",
        });

        const priorityColor = computed(() => {
            switch (incidentData.value.prio) {
                case "Low":
                    return "bg-lightblue-500";
                case "Medium":
                    return "bg-yellow-500";
                case "High":
                    return "bg-red-500";
                default:
                    return "bg-lightblue-500";
            }
        });

        const setSensuProjectCheck = (events) => {
            incidentData.value.projectChecks.sensu = events;
        };

        const openIncidentCreateWhenKeyPressed = (e) => {
            // 84 = Key 'T"
            if (e.altKey && e.keyCode === 84) {
                isCreateModalOpen.value = true;
            }
        };
        document.addEventListener("keydown", openIncidentCreateWhenKeyPressed, false);

        const createIncident = () => {
            Inertia.post(route("universal.incidents.store"), incidentData.value, {
                onStart: () => {
                    steps.value.forEach((step) => {
                        step.hasIssue = false;
                    });

                    showErrors.value = false;
                    isSubmitting.value = true;
                },
                onFinish: () => {
                    isSubmitting.value = false;
                },
                onError: () => {
                    showErrors.value = true;

                    if (errors.value.affectedProjects) {
                        steps.value[0].hasIssue = true;
                    }

                    if (errors.value.title || errors.value.description) {
                        steps.value[2].hasIssue = true;
                    }
                    if (errors.value.projectChecks) {
                        steps.value[1].hasIssue = true;
                    }
                },
            });
        };

        const cancelCreate = () => {
            incidentData.value.title = "";
            incidentData.value.description = "";
            incidentData.value.resolved = false;
            incidentData.value.prio = "Medium";
            incidentData.value.affectedProjects = [];
            incidentData.value.projectChecks = {
                sensu: [],
                uptimeRobot: [],
            };

            steps.value.forEach((step) => {
                step.hasIssue = false;
            });

            currentStep.value = 0;
            isCreateModalOpen.value = false;
        };

        const activeStyling = "underline";

        return {
            isCreateModalOpen,
            isSubmitting,
            currentStep,
            steps,
            incidentData,
            errors,
            priorityColor,
            intergrations,
            activeStyling,
            sensuStateColors,
            createIncident,
            cancelCreate,
            setSensuProjectCheck,
        };
    },
};
</script>
